export default "__VITE_ASSET__zNMKxbpz__"